const initialState = {
  suppliers: [],
  activeSuppliers: [],
  loading: false,
  activeLoading: false,
  actionLoading: false,
  error: null
};

const SupplierReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch all suppliers (management grid)
    case 'FETCH_SUPPLIERS_M_REQUEST':
      return { ...state, loading: true, error: null };
    case 'FETCH_SUPPLIERS_M_SUCCESS':
      return { ...state, loading: false, suppliers: action.payload, error: null };
    case 'FETCH_SUPPLIERS_M_FAILURE':
      return { ...state, loading: false, error: action.payload };

    // Fetch active suppliers (batch-create dropdown)
    case 'FETCH_ACTIVE_SUPPLIERS_REQUEST':
      return { ...state, activeLoading: true, error: null };
    case 'FETCH_ACTIVE_SUPPLIERS_SUCCESS':
      return { ...state, activeLoading: false, activeSuppliers: action.payload, error: null };
    case 'FETCH_ACTIVE_SUPPLIERS_FAILURE':
      return { ...state, activeLoading: false, error: action.payload };

    // Create Supplier
    case 'CREATE_SUPPLIER_REQUEST':
      return { ...state, actionLoading: true, error: null };
    case 'CREATE_SUPPLIER_SUCCESS':
      return {
        ...state,
        actionLoading: false,
        suppliers: [action.payload, ...state.suppliers],
        activeSuppliers: action.payload.isActive
          ? [action.payload, ...state.activeSuppliers]
          : state.activeSuppliers,
        error: null
      };
    case 'CREATE_SUPPLIER_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    // Update Supplier (incl. activate/deactivate)
    case 'UPDATE_SUPPLIER_REQUEST':
      return { ...state, actionLoading: true, error: null };
    case 'UPDATE_SUPPLIER_SUCCESS':
      return {
        ...state,
        actionLoading: false,
        suppliers: state.suppliers.map((s) => (s.id === action.payload.id ? action.payload : s)),
        activeSuppliers: action.payload.isActive
          ? [...state.activeSuppliers.filter((s) => s.id !== action.payload.id), action.payload]
          : state.activeSuppliers.filter((s) => s.id !== action.payload.id),
        error: null
      };
    case 'UPDATE_SUPPLIER_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    default:
      return state;
  }
};

export default SupplierReducer;
